/** @format */

import { Input } from "antd";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";

import pdf from "../../../icons/pdf.png";
import excel from "../../../icons/excel.png";
import print from "../../../icons/print.png";
import { ExcelPrint, Pdf } from "../../../components/functions/Print";

const Table21 = () => {
  const conponentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Statistik hisobotlar",
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Statistik hisobotlar", "sheet 1", "tblData")
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead'>
        <div ref={conponentPDF} style={{ width: "100%" }}>
          <table id='tblData' className='table table-bordered table-style'>
            <thead>
              <tr>
                <th rowSpan={3} scope='col'>
                  №
                </th>

                <th colSpan={8} scope='col'>
                  1 bo’lim. Birlamchi suvdan foydalanuvchilar tomonidan
                  foydalanilgan suv to’g’risidagi xisobot
                </th>
              </tr>

              <tr>
                <th rowSpan={2} scope='col'>
                  Suv manbalari nomi (daryo, soy, kanal, suv ombori, kollektor,
                  quduq va boshqalari)
                </th>

                <th rowSpan={2} scope='col'>
                  Suv olish joyining nomi
                </th>

                <th colSpan={2} scope='col'>
                  Gidrologik yilda
                </th>

                <th rowSpan={2} scope='col'>
                  Jami sug’orish ishlari, ga
                </th>

                <th colSpan={2} scope='col'>
                  Shu jumladan
                </th>

                <th rowSpan={2} scope='col'>
                  Sho’r yuvish, ga
                </th>
              </tr>

              <tr>
                <th scope='col'>Ajratilgan limit, mln. m3</th>
                <th scope='col'>Amalda olingani, mln. m3</th>
                <th scope='col'>G’o’za, ga</th>
                <th scope='col'>Kuzgi boshoqli don, ga</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <th>1</th>
                <th> Qoraqalpog’iston Respublikasi Suv xo’jaligi vazirligi</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>2</th>
                <th> Sh. J. Amudaryo</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>3</th>
                <th> O’ng qirg’ooq kanali</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>4</th>
                <th> Upradik tizimi</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>5</th>
                <th> Sh. J. Gurlen vetkasidan</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>6</th>
                <th> Qipchoq Bozsu vetkasidan</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>7</th>
                <th> Qilichboy vetkasidan</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>8</th>
                <th> Daryodan nasoslar orqali Qipchoqqacha</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>9</th>
                <th> Suenli</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>10</th>
                <th> Parallel</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>11</th>
                <th> GRES kanali</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>12</th>
                <th> Qizketken</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>13</th>
                <th> Risoviy</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>14</th>
                <th> Daryodan nasos. orqali Qipchoqdan keyin</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>15</th>
                <th> Yer osti</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>

              <tr>
                <th>16</th>
                <th> Zovurlar</th>
                <td></td>
                <td>2.9</td>
                <td>1296</td>
                <td>1296</td>
                <td>2.9</td>
                <td>1296</td>
                <td>53</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Table21;
